import './Indicadores.css';

export default function Indicadores() {
  return (
    <section className="indicadores">
      
     <div className="indicador">
        <h2>+ de 60.000 Mil</h2>
        <p>Toneladas recicladas al año</p>
      </div>

      <div className="indicador">
        <h2>+ de 20 Árboles</h2>
        <p>por toneladas recicladas se salvan</p>
      </div>

      <div className="indicador">
        <h2>+ de 3.000 Mil</h2>
        <p>Toneladas de papel producidos mes a mes</p>
      </div>

    </section>
  );
}